/**
 * Collapses duplicate slashes in a URL pathname.
 * Email/OLB deep links sometimes arrive as `//a/fm`, which browsers and
 * history.replaceState interpret as a protocol-relative URL (host `a`).
 */
export function normalizePathname(pathname: string): string {
  if (!pathname) {
    return '/';
  }

  const collapsed = pathname.replace(/\/+/g, '/');

  if (collapsed === '/') {
    return '/';
  }

  return collapsed.startsWith('/') ? collapsed : `/${collapsed}`;
}
